<template>
    <div>
        <!-- Tabs Navigation -->
        <div class="tabs-container">
            <b-card no-body>
                <b-tabs card>
                    <!-- Product Stats Tab -->
                    <b-tab title="Product Stats" active>
                        <div>
                            <div v-if="items_being_loaded == true">
                                <loading :active="items_being_loaded" 
                                    :can-cancel="true" 
                                    :is-full-page="false">
                                </loading>
                            </div>
                            <div v-else>
                                <div v-if="items_being_loaded == false">
                                    <div v-if="items.length > 0">
                                        <table style="width: 100%;">
                                            <thead>
                                                <tr>
                                                    <td class="srr">LOCATION</td>
                                                    <td class="srr">IN STOCK</td>
                                                    <td class="srr">7 DAYS SOLD</td>
                                                    <td class="srr">30 DAYS SOLD</td>
                                                    <td class="srr">60 DAYS SOLD</td>
                                                    <td class="srr">90 DAYS SOLD</td>
                                                    <td class="srr">ALL DAYS SOLD</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item,idx in items" v-bind:key="idx">
                                                    <td class="srrv">{{packet.locationsdict[item.location_id]}}</td>
                                                    <td class="srrv" :style="{background: get_background(item.current_stock)}">{{item.current_stock}}</td>
                                                    <td class="srrv" :style="{background: get_background(item.sold_last_7_days)}">{{item.sold_last_7_days}}</td>
                                                    <td class="srrv" :style="{background: get_background(item.sold_last_30_days)}">{{item.sold_last_30_days}}</td>
                                                    <td class="srrv" :style="{background: get_background(item.sold_last_60_days)}">{{item.sold_last_60_days}}</td>
                                                    <td class="srrv" :style="{background: get_background(item.sold_last_90_days)}">{{item.sold_last_90_days}}</td>
                                                    <td class="srrv" style="background: lightgreen">{{item.sold}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div v-else>
                                        <b-alert show variant="warning">NO STATS FOR THE PRODUCT YET</b-alert>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Parent Product Details Section -->
                        <div style="margin-top: 10px;" v-if="product.is_parent">
                            <div v-if="parent_product_details_being_loaded == true">
                                <loading :active="parent_product_details_being_loaded" 
                                    :can-cancel="true" 
                                    :is-full-page="false">
                                </loading>
                            </div>
                            <div v-else>
                                <div v-if="parent_product_details_being_loaded == false">
                                    <div v-if="children.length > 0">
                                        
                                        <div style="display: inline-block;">
                                            <div class="text-center">
                                                <b-button variant="primary">
                                                    <span style="font-size: 12px;">CURRENT SELL PRICE</span>
                                                    <b-badge variant="light">{{formatPrice(children[0].selling_price)}} <span class="sr-only"></span></b-badge>
                                                </b-button>
                                            </div>
                                        </div>

                                        <div style="display: inline-block;">
                                            <div class="text-center">
                                                <b-button variant="success">
                                                    <span style="font-size: 12px;">NEW SELL PRICE</span>
                                                    <b-badge variant="light">{{formatPrice(sum_children_selling_price())}} <span class="sr-only"></span></b-badge>
                                                </b-button>
                                            </div>
                                        </div>
                                        <div style="display: inline-block;">
                                            <div class="text-center">
                                                <b-button variant="primary">
                                                    <span style="font-size: 12px;">LANDED CST</span>
                                                    <b-badge variant="light">{{formatPrice(sum_children_landed_cost())}} <span class="sr-only"></span></b-badge>
                                                </b-button>
                                            </div>
                                        </div>
                                        <div style="display: inline-block;">
                                            <div class="text-center">
                                                <b-button variant="primary">
                                                    <span style="font-size: 12px;">WHLSL PRICE</span>
                                                    <b-badge variant="light">{{formatPrice(sum_children_wholesale_price())}} <span class="sr-only"></span></b-badge>
                                                </b-button>
                                            </div>
                                        </div>
                                        <div style="display: inline-block;">
                                            <div class="text-center">
                                                <b-button variant="success">
                                                    <span style="font-size: 12px;">CUBES</span>
                                                    <b-badge variant="light">{{formatNumber(sum_children_cubes())}} <span class="sr-only"></span></b-badge>
                                                </b-button>
                                            </div>
                                        </div>
                                        <div style="display: inline-block;">
                                            <div class="text-center">
                                                <b-button variant="primary">
                                                    <span style="font-size: 12px;">SPIFF</span>
                                                    <b-badge variant="light">{{formatPrice(product.spiff)}} <span class="sr-only"></span></b-badge>
                                                </b-button>
                                            </div>
                                        </div>

                                        <div style="display: inline-block;">
                                            <div class="text-center">
                                                <b-button variant="danger" @click="update_product_group_details">
                                                    SAVE
                                                </b-button>
                                            </div>
                                        </div>

                                        <!-- Updated Table with Additional Columns -->
                                        <table style="width: 100%; margin-top: 5px;">
                                            <thead>
                                                <tr>
                                                    <td class="srr2" style="width: 130px;">CHILD SKU</td>
                                                    <td class="srr2" style="width: 80px;">ORIG PRICE</td>
                                                    <td class="srr2" style="width: 70px;">QTY</td>
                                                    <td class="srr2" style="width: 80px;">PRICE/UNIT</td>
                                                    <td class="srr2" style="width: 80px;">ORIG TOTAL</td>
                                                    <td class="srr2" style="width: 70px;">RATIO</td>
                                                    <td class="srr2" style="width: 90px;">UNIT GRP PRICE</td>
                                                    <td class="srr2" style="width: 90px;">TOTAL GRP PRICE</td>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr v-for="(child, cidx) in children" v-bind:key="cidx">
                                                    <td class="srrv2">{{child.child_product_sku}}</td>
                                                    <td class="srrv2">{{formatPrice(child.child_selling_price)}}</td>
                                                    <td class="srrv2">
                                                        <b-input size="sm" 
                                                            v-model="child.quantity" 
                                                            type="number"
                                                            min="1"
                                                            @input="updateTotalSellingPrice"></b-input>
                                                    </td>
                                                    <td class="srrv2" style="background: #e8f4f8; font-weight: bold;">
                                                        {{formatPrice(child.child_selling_price / child.quantity)}}
                                                    </td>
                                                    <td class="srrv2" style="background: #e8f4f8;">
                                                        {{formatPrice(child.child_selling_price * child.quantity)}}
                                                    </td>
                                                    <td class="srrv2" style="background: #f0f0f0;">
                                                        {{getRatio(child.child_selling_price, child.quantity)}}%
                                                    </td>
                                                    <td class="srrv2" style="background: #fff3cd;">
                                                        <b-input size="sm" 
                                                            v-model="child.unit_selling_price" 
                                                            type="number"
                                                            step="0.01"
                                                            min="0"
                                                            @input="updateTotalSellingPrice"></b-input>
                                                    </td>
                                                    <td class="srrv2" style="background: #d4edda; font-weight: bold;">
                                                        {{formatPrice((child.unit_selling_price || 0) * (child.quantity || 1))}}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td class="srrv2" colspan="5">
                                                        <strong>ORIG TOTAL</strong>
                                                        <b-input size="sm" :disabled="true" style="background: lightblue; color: black; margin-top: 5px;" 
                                                            :value="formatPrice(children.map(function(d){return (parseFloat(d.child_selling_price) || 0.0)}).reduce((partialSum, a) => partialSum + a, 0))">
                                                        </b-input>
                                                    </td>
                                                    <td class="srrv2"></td>
                                                    <td class="srrv2" colspan="2">
                                                        <strong>SELLING PRICE</strong>
                                                        <b-input size="sm" style="background: lightyellow; font-weight: bold; color: black; margin-top: 5px;" 
                                                            v-model="selling_price" type="number" step="0.01" @input="onSellingPriceChange">
                                                        </b-input>
                                                    </td>
                                                </tr>

                                                <!-- Summary Row -->
                                                <tr style="background: #f8f9fa; border-top: 3px solid #dee2e6;">
                                                    <td class="srrv2" colspan="2"></td>
                                                    <td class="srrv2"><strong>Total QTY</strong><br>{{sum_quantities()}}</td>
                                                    <td class="srrv2"></td>
                                                    <td class="srrv2"><strong>Total Orig</strong><br>{{formatPrice(calculate_orig_total())}}</td>
                                                    <td class="srrv2"></td>
                                                    <td class="srrv2"><strong>Total Unit</strong><br>{{formatPrice(sum_unit_prices())}}</td>
                                                    <td class="srrv2" style="background: #d4edda; font-weight: bold;">
                                                        <strong>Total GRP</strong><br>{{formatPrice(sum_children_selling_price())}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <b-alert show variant="warning">NO CHILD ADDED YET</b-alert>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>

                    <!-- Price Receiving History Tab -->
                    <b-tab title="Receiving History">
                        <div>
                            <div v-if="history_being_loaded">
                                <loading :active="history_being_loaded" 
                                    :can-cancel="true" 
                                    :is-full-page="false">
                                </loading>
                            </div>
                            <div v-else>
                                <div v-if="receivingHistory.length > 0">
                                    <table style="width: 100%;" class="history-table">
                                        <thead>
                                            <tr>
                                                <th class="srr">Product Name</th>
                                                <th class="srr">Location</th>
                                                <th class="srr">Received Date</th>
                                                <th class="srr">Source</th>
                                                <th class="srr">Sale Price</th>
                                                <th class="srr">Landed</th>
                                                <th class="srr">Profit Margin</th>
                                                <th class="srr">Qty Received</th>
                                                <th class="srr">Sold So Far</th>
                                                <th class="srr">Balance Stock</th>
                                                <th class="srr">Total Stock</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(history, idx) in receivingHistory" :key="idx">
                                                <td class="srrv">{{ history.product_name }}</td>
                                                <td class="srrv">{{ history.location_name || 'N/A' }}</td>
                                                <td class="srrv">{{ history.receiving_date_formatted || 'N/A' }}</td>
                                                <td class="srrv">
                                                    <b-badge :variant="getSourceVariant(history.source_type)">
                                                        {{ history.source_type }}
                                                    </b-badge>
                                                </td>
                                                <td class="srrv">${{ formatPrice(history.selling_price) }}</td>
                                                <td class="srrv">${{ formatPrice(history.landed_cost) }}</td>
                                                <td class="srrv" :style="{ background: getProfitMarginColor(history.profit_margin) }">
                                                    {{ formatNumber(history.profit_margin) }}%
                                                </td>
                                                <td class="srrv">{{ history.quantity_received }}</td>
                                                <td class="srrv">{{ history.sold_so_far }}</td>
                                                <td class="srrv" :style="{ background: getBalanceStockColor(history.balance_stock) }">
                                                    {{ history.balance_stock }}
                                                </td>
                                                <td class="srrv">{{ history.in_stock }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else>
                                    <b-alert show variant="info">No receiving history found for this product.</b-alert>
                                </div>
                            </div>
                        </div>
                    </b-tab>

                    <b-tab title="Price Change History">
                        <div>
                            <div v-if="history_loading">
                                <loading :active="history_loading" 
                                    :can-cancel="true" 
                                    :is-full-page="false">
                                </loading>
                            </div>
                            <div v-else>
                                <div v-if="changeHistory.length > 0">
                                    <table style="width: 100%;" class="history-table">
                                        <thead>
                                            <tr>
                                                <th class="srr">Change Date</th>
                                                <th class="srr">Field</th>
                                                <th class="srr">Previous Value</th>
                                                <th class="srr">New Value</th>
                                                <th class="srr">Changed By</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(history, idx) in changeHistory" :key="idx">
                                                <td class="srrv">{{ formatDateTime(history.change_date) }}</td>
                                                <td class="srrv">{{ formatFieldName(history.changed_field) }}</td>
                                                <td class="srrv" style="color: red;">
                                                    <s>{{ formatValue(history.changed_field, history.previous_value) || 'N/A' }}</s>
                                                </td>
                                                <td class="srrv" style="color: green; font-weight: bold;">
                                                    {{ formatValue(history.changed_field, history.new_value) || 'N/A' }}
                                                </td>
                                                <td class="srrv">{{ history.changed_by || 'System' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else>
                                    <b-alert show variant="info">No change history found for this product.</b-alert>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "ProductStatsModal",
        props: ["viewdata"],
        components: {Loading},
        data: function(){
            return {
                packet: {},
                items: [],
                items_being_loaded: null,
                product: {},
                parent_product_details_being_loaded: null,
                children: [],
                selling_price: null,
                new_selling_price: null,
                receivingHistory: [],
                history_being_loaded: null,
                manualPriceUpdate: false,
                isUpdating: false,
                
                changeHistory: [],
                history_loading: false,
                historyFilter: {
                    field: '',
                    dateRange: ['', ''] 
                },
                historyFields: [
                    { key: 'change_date', label: 'Date', sortable: true },
                    { key: 'changed_field', label: 'Field', sortable: true },
                    { key: 'previous_value', label: 'Previous Value', sortable: true },
                    { key: 'new_value', label: 'New Value', sortable: true },
                    { key: 'changed_by', label: 'Changed By', sortable: true },
                    { key: 'actions', label: 'Actions' }
                ],
                historyPerPage: 10,
                historyCurrentPage: 1,
                showDetailsModal: false,
                selectedChange: null,
                fieldOptions: [
                    { value: 'product_name', text: 'Product Name' },
                    { value: 'selling_price', text: 'Selling Price' },
                    { value: 'landed_cost', text: 'Landed Cost' },
                    { value: 'fob_price', text: 'FOB Price' },
                    { value: 'wholesale_price', text: 'Wholesale Price' },
                    { value: 'spiff', text: 'Spiff' },
                    { value: 'cubes', text: 'Cubes' },
                    { value: 'category_id', text: 'Category' },
                    { value: 'vendor_id', text: 'Vendor' }
                ]
            }
        },
        watch: {
            selling_price: {
                handler: function(val) {
                    if (this.isUpdating) return;
                    
                    if (this.manualPriceUpdate) {
                        this.manualPriceUpdate = false;
                        return;
                    }
                    
                    this.distributeSellingPrice(val);
                },
                immediate: true
            }
        },

        computed: {
            filteredHistory() {
                let filtered = this.changeHistory;
                
                if (this.historyFilter.field) {
                    filtered = filtered.filter(item => 
                        item.changed_field === this.historyFilter.field
                    );
                }
                
                if (this.historyFilter.dateRange[0]) {
                    filtered = filtered.filter(item => 
                        moment(item.change_date).isSameOrAfter(this.historyFilter.dateRange[0])
                    );
                }
                
                if (this.historyFilter.dateRange[1]) {
                    filtered = filtered.filter(item => 
                        moment(item.change_date).isSameOrBefore(this.historyFilter.dateRange[1] + ' 23:59:59')
                    );
                }
                
                return filtered;
            }
        },
        methods: {
            // Helper function to round to 2 decimal places
            roundToTwo(num) {
                return Math.round((num) * 100) / 100;
            },

            distributeSellingPrice(val) {
                if (this.isUpdating) return;
                this.isUpdating = true;
                
                try {
                    let new_selling_price = parseFloat(val);
                    if (!new_selling_price || new_selling_price <= 0 || this.children.length === 0) {
                        this.isUpdating = false;
                        return;
                    }
                    
                    // Calculate total original price
                    let total_orig_price = 0;
                    this.children.forEach(child => {
                        const origPrice = parseFloat(child.child_selling_price) || 0;
                        total_orig_price += origPrice;
                    });
                    
                    if (total_orig_price <= 0) {
                        this.isUpdating = false;
                        return;
                    }
                    
                    // First pass: calculate all unit prices
                    let totalCalculated = 0;
                    let unitPrices = [];
                    
                    this.children.forEach((child, index) => {
                        const qty = parseFloat(child.quantity) || 1;
                        const origPrice = parseFloat(child.child_selling_price) || 0;
                        
                        // Calculate ratio
                        const ratio = origPrice / total_orig_price;
                        
                        // Calculate total selling price for this SKU
                        const totalSellingPrice = new_selling_price * ratio;
                        
                        // Calculate unit selling price (divide by quantity)
                        const unitPrice = totalSellingPrice / qty;
                        
                        // Round to 2 decimal places
                        const roundedUnitPrice = this.roundToTwo(unitPrice);
                        
                        unitPrices.push({
                            index: index,
                            unitPrice: roundedUnitPrice,
                            totalPrice: roundedUnitPrice * qty
                        });
                        
                        totalCalculated += roundedUnitPrice * qty;
                    });
                    
                    // Calculate the difference due to rounding
                    let difference = this.roundToTwo(new_selling_price - totalCalculated);
                    
                    // Apply the difference to the item with the largest quantity (to minimize impact)
                    if (Math.abs(difference) > 0.01) {
                        // Find the item with the largest quantity
                        let maxQtyIndex = 0;
                        let maxQty = 0;
                        this.children.forEach((child, index) => {
                            const qty = parseFloat(child.quantity) || 1;
                            if (qty > maxQty) {
                                maxQty = qty;
                                maxQtyIndex = index;
                            }
                        });
                        
                        // Adjust the unit price of that item
                        const qty = parseFloat(this.children[maxQtyIndex].quantity) || 1;
                        const currentUnitPrice = unitPrices.find(u => u.index === maxQtyIndex).unitPrice;
                        const newUnitPrice = this.roundToTwo(currentUnitPrice + (difference / qty));
                        unitPrices.find(u => u.index === maxQtyIndex).unitPrice = newUnitPrice;
                    }
                    
                    // Apply the calculated unit prices
                    unitPrices.forEach(({index, unitPrice}) => {
                        this.children[index].unit_selling_price = unitPrice;
                    });
                    
                    this.new_selling_price = new_selling_price;
                    
                } catch (error) {
                    console.error('Error distributing selling price:', error);
                } finally {
                    this.isUpdating = false;
                }
            },
            
            getRatio(origPrice, qty) {
                if (!this.children || this.children.length === 0) return '0';
                
                const totalOrig = this.children.reduce((sum, child) => {
                    const price = parseFloat(child.child_selling_price) || 0;
                    return sum + price;
                }, 0);
                
                if (totalOrig === 0) return '0';
                
                const ratio = (origPrice / totalOrig) * 100;
                return ratio.toFixed(1);
            },
            
            sum_quantities: function() {
                let total = 0;
                this.children.forEach(child => {
                    total += parseFloat(child.quantity) || 0;
                });
                return total;
            },
            
            calculate_orig_total: function() {
                let total = 0;
                this.children.forEach(child => {
                    const price = parseFloat(child.child_selling_price) || 0;
                    total += price;
                });
                return total;
            },
            
            sum_unit_prices: function() {
                let total = 0;
                this.children.forEach(child => {
                    total += parseFloat(child.unit_selling_price) || 0;
                });
                return total;
            },
            
            updateTotalSellingPrice() {
                if (this.isUpdating) return;
                
                this.manualPriceUpdate = true;
                
                const total = this.sum_children_selling_price();
                this.selling_price = this.roundToTwo(total);
                this.new_selling_price = this.selling_price;
            },
            
            onSellingPriceChange() {
                // The watch handler will handle distribution
            },
            
            async fetchHistory() {
                if (!this.product || !this.product.sku) return;
                
                this.history_loading = true;
                const path = "/api/product/get_product_change_history/";
                const data = { product_sku: this.product.sku };
                
                try {
                    const response = await new Promise((resolve, reject) => {
                        Requestor.postSyncP(path, data, this, resolve, reject);
                    });
                    
                    if (response.data.result) {
                        this.changeHistory = response.data.result;
                    } else {
                        this.$bvToast.toast(
                            response.data.error || "Error fetching product history",
                            { title: "Error", variant: "warning" }
                        );
                    }
                } catch (error) {
                    console.error('Error fetching product history:', error);
                    this.$bvToast.toast(
                        "Error fetching product history",
                        { title: "Error", variant: "danger" }
                    );
                } finally {
                    this.history_loading = false;
                }
            },
            
            formatDateTime(dateString) {
                return moment(dateString).format('YYYY-MM-DD HH:mm:ss');
            },
            
            formatFieldName(field) {
                const fieldMap = {
                    'product_name': 'Product Name',
                    'selling_price': 'Selling Price',
                    'landed_cost': 'Landed Cost',
                    'fob_price': 'FOB Price',
                    'wholesale_price': 'Wholesale Price',
                    'spiff': 'Spiff',
                    'cubes': 'Cubes',
                    'category_id': 'Category',
                    'vendor_id': 'Vendor'
                };
                return fieldMap[field] || field;
            },
            
            formatValue(field, value) {
                if (!value) return '';
                
                const numericFields = ['selling_price', 'landed_cost', 'fob_price', 'wholesale_price', 'spiff', 'cubes'];
                if (numericFields.includes(field)) {
                    const num = parseFloat(value);
                    return isNaN(num) ? value : num.toFixed(2);
                }
                
                if (field === 'category_id' && this.packet.categoriesdict) {
                    return this.packet.categoriesdict[value] || value;
                }
                
                if (field === 'vendor_id' && this.packet.vendorsdict) {
                    return this.packet.vendorsdict[value] || value;
                }
                
                return value;
            },
            
            showChangeDetails(change) {
                this.selectedChange = change;
                this.showDetailsModal = true;
            },
            
            clearHistoryFilters() {
                this.historyFilter = {
                    field: '',
                    startDate: '',
                    endDate: ''
                };
            },
            
            formatPrice(value) {
                if (value === null || value === undefined) return '0.00';
                try {
                    const num = parseFloat(value);
                    return isNaN(num) ? '0.00' : num.toFixed(2);
                } catch (e) {
                    return '0.00';
                }
            },
            
            formatNumber(value) {
                if (value === null || value === undefined) return '0';
                try {
                    const num = parseFloat(value);
                    return isNaN(num) ? '0' : num.toFixed(2);
                } catch (e) {
                    return '0';
                }
            },
            
            getSourceVariant(sourceType) {
                switch(sourceType) {
                    case 'STOCK_ORDER': return 'primary';
                    case 'CONTAINER_ORDER': return 'success';
                    case 'BACKORDER': return 'warning';
                    default: return 'secondary';
                }
            },
            
            getProfitMarginColor(margin) {
                let marginValue = 0;
                try {
                    marginValue = parseFloat(margin) || 0;
                } catch (e) {
                    marginValue = 0;
                }
                
                if (marginValue > 50) return '#d4edda';
                if (marginValue > 20) return '#fff3cd';
                return '#f8d7da';
            },
            
            getBalanceStockColor(balance) {
                let balanceValue = 0;
                try {
                    balanceValue = parseFloat(balance) || 0;
                } catch (e) {
                    balanceValue = 0;
                }
                
                if (balanceValue > 0) return '#d4edda';
                if (balanceValue < 0) return '#f8d7da';
                return '#fff3cd';
            },
            
            fetch_receiving_history: function() {
                let path = "/api/sales/get_price_receiving_history/";
                let data = { product_sku: this.product.sku };
                let that = this;
                
                let s = function(response) {
                    if (response.data.result) {
                        that.receivingHistory = response.data.result.map(item => ({
                            ...item,
                            selling_price: parseFloat(item.selling_price) || 0,
                            landed_cost: parseFloat(item.landed_cost) || 0,
                            profit_margin: parseFloat(item.profit_margin) || 0,
                            quantity_received: parseInt(item.quantity_received) || 0,
                            sold_so_far: parseInt(item.sold_so_far) || 0,
                            balance_stock: parseInt(item.balance_stock) || 0,
                            in_stock: parseInt(item.in_stock) || 0
                        }));
                    } else {
                        that.$bvToast.toast(
                            response.data.error || "Error fetching receiving history",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.history_being_loaded = false;
                };
                
                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error fetching receiving history",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.history_being_loaded = false;
                };
                
                this.history_being_loaded = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },
            
            sum_children_cubes: function(){
                let output = 0.0;
                for (var i=0; i<this.children.length; i++){
                    output += this.children[i].child_cubes * (this.children[i].quantity || 0)
                }
                return output
            },
            
            sum_children_landed_cost: function(){
                let output = 0.0;
                for (var i=0; i<this.children.length; i++){
                    output += this.children[i].child_landed_cost * (this.children[i].quantity || 0)
                }
                return output
            },
            
            sum_children_wholesale_price: function(){
                let output = 0.0;
                for (var i=0; i<this.children.length; i++){
                    output += this.children[i].child_wholesale_price * (this.children[i].quantity || 0)
                }
                return output
            },
            
            sum_children_selling_price: function(){
                let output = 0.0;
                for (var i=0; i<this.children.length; i++){
                    const unitPrice = parseFloat(this.children[i].unit_selling_price) || 0;
                    const quantity = parseFloat(this.children[i].quantity) || 0;
                    output += unitPrice * quantity;
                }
                // Round the final total to 2 decimal places
                return this.roundToTwo(output);
            },
            
            get_background: function(value){
                if (value > 0){
                    return 'lightyellow'
                }
                else {
                    return 'white'
                }
            },
            
            update_product_group_details: function(){
                let path = "/api/product/update_product_group_details/"
                let that = this;
                let data = {"children": this.children}
                data["parent_product_sku"] = this.children[0].parent_product_sku;
                data["parent_product_selling_price"] = this.new_selling_price;
                data["parent_product_wholesale_price"] = this.sum_children_wholesale_price();
                data["parent_product_landed_cost"] = this.sum_children_landed_cost();
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$emit("changed-product", JSON.stringify({"product_sku": that.product.sku, "selling_price": parseFloat(that.new_selling_price)}));
                        that.$bvToast.toast(
                            "Success", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    
                    that.parent_product_details_being_loaded = false
                    that.fetch_children()
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating group details.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.parent_product_details_being_loaded=false
                }
                this.parent_product_details_being_loaded = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },
            
            fetch_init: function(){
                let path = "/api/sales/get_item_stats_v1/"
                let data = {product_sku: this.product.sku, is_parent: this.product.is_parent}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error fetching product stats.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded=false
                }
                this.items_being_loaded = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },
            
            close_it: function(){
                this.$emit("done-product-stats");
            },
            
            fetch_children: function(){
                let that = this;
                if(this.product.is_parent){
                    let path = "/api/product/get_parent_product_details/"
                    let data = {product_sku: this.product.sku}

                    let s = function(response){
                        if (response.data.result){
                            that.children = response.data.result;
                            that.children.forEach(child => {
                                if (!child.unit_selling_price && child.child_selling_price) {
                                    const qty = parseFloat(child.quantity) || 1;
                                    child.unit_selling_price = that.roundToTwo(child.child_selling_price / qty);
                                }
                                if (!child.quantity) {
                                    child.quantity = 1;
                                }
                            });
                            that.updateTotalSellingPrice();
                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error, 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        that.parent_product_details_being_loaded = false
                    }
                    let f = function(error){
                        console.log(error)
                        that.$bvToast.toast(
                            "Error fetching product stats.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.parent_product_details_being_loaded=false
                    }
                    this.parent_product_details_being_loaded = true;
                    Requestor.getAsyncP(path, data, this, s, f);   
                }
            }
        },
        
        mounted: async function(){
            await Promise.all([
                this.fetch_init(),
                this.fetch_children(),
                this.fetch_receiving_history(),
                this.fetchHistory()
            ]);
        },
        
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.product = JSON.parse(JSON.stringify(this.viewdata)); 
            this.selling_price = parseFloat(JSON.stringify(this.product.selling_price));
        }
    }
</script>

<style scoped>
.filters-container .form-group {
    margin-bottom: 0.5rem;
}

.filters-container .b-form-group-label {
    padding-bottom: 0.25rem;
}

.filters-container .b-form-group-label label {
    font-size: 0.875rem;
    font-weight: 500;
}

.filters-container .form-control-sm {
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
}

.filters-container .btn-group-sm > .btn,
.filters-container .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}

.filters-container .b-form-datepicker {
    max-width: 100%;
}

.filters-container .b-form-datepicker .form-control {
    font-size: 0.875rem;
}

.history-tab {
    max-height: 600px;
    overflow-y: auto;
}

.text-danger s {
    opacity: 0.7;
}

.text-success strong {
    font-weight: bold;
}

.history-tab .table {
    font-size: 12px;
}

.history-tab .table th,
.history-tab .table td {
    padding: 4px 8px;
    vertical-align: middle;
}

.tabs-container {
    margin-top: 10px;
}

.history-table {
    font-size: 11px;
}

.history-table th,
.history-table td {
    padding: 4px 6px;
    text-align: center;
    white-space: nowrap;
}

.date .input-group-text  {
    padding: 0;
    padding-left: 10px;
    padding-right: 10px;
}

.srr {
    font-size: 11px;
    text-align: center;
    background: #efefef;
    border: 1px solid #010101;
}

.srrv {
    font-size: 11px;
    text-align: center;
    background: white;
    border: 1px solid #010101;
    padding: 5px;
}

.srr2 {
    font-size: 14px;
    text-align: center;
    background: #efefef;
    border: 1px solid #010101;
}

.srrv2 {
    font-size: 14px !important;
    text-align: center;
    background: white;
    border: 1px solid #010101;
    padding: 5px;
}

.srrv2 input {
    text-align: center;
}

.modal-xl {
    min-width: 1000px !important;
}

.mx-input {
    font-size: 12px;
}

.srrv2 input[type="number"] {
    width: 100%;
    padding: 4px;
    border: 1px solid #ced4da;
    border-radius: 4px;
}

.srrv2 input[type="number"]:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}

.summary-row td {
    font-weight: bold;
    background-color: #f8f9fa !important;
}

@media (max-width: 1200px) {
    .srrv2 {
        font-size: 12px !important;
        padding: 3px !important;
    }
    
    .srrv2 input {
        font-size: 12px !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Products/ProductStatsModal.vue